module.exports = __webpack_public_path__ + "static/media/brand-story-meaning1.de0d9f1e.png";